import { Router, RouteRecordRaw } from 'vue-router'
import createRouter from '@/router/getRouter.ts'
import otivoRoutes from '@/router/otivoRoutes.ts'
import cfsRoutes from '@/router/clients/cfs/cfsRoutes.ts'
import publicRoutes from '@/router/publicRoutes.ts'
import adminPortalRoutes from '@/router/adminPortalRoutes.ts'
import cfsAdminPortalRoutes from '@/router/clients/cfs/adminPortalRoutes.ts'
import { useSessionStore } from '@/store/pinia/SessionStore.ts'
import { useUserStore } from '@/store/pinia/UserStore.ts'
import { useAccountFlagsStore } from '@/store/pinia/AccountFlagsStore.ts'
import { FeatureList, useLDFlag } from '@/lib/ldClient.ts'

const freemiumEnabled = useLDFlag(FeatureList.ENABLE_FREEMIUM, false)
const adviserHomepageEnabled = useLDFlag(FeatureList.ENABLE_ADVISER_HOMEPAGE, false)

export type InstanceRecord = {
  [key: string]: FrontendInstance
}

export type FrontendInstance = {
  AUTH0_ID: string
  ROUTER: Router
  SENTRY_ID: string
}

type FrontendConfig = {
  entry: string
  auth0_client_id: string
  router: string
  sentry_dsn: string
}

// UPDATE DEFAULT ROUTE OBJECTS HERE
const ROUTES: { [key: string]: RouteRecordRaw[] } = {
  otivoRouter: otivoRoutes, // TODO: rename this to baseRouter
  cfsRouter: cfsRoutes, // May have to dependency inject stores here to avoid circular dependencies
}

// UPDATE ENTRY POINT COMPONENTS HERE
// const entryPoints: { [key: string]: Component } = {
//   Main: Main,
// }

// export const getEntry = (entryKey: string): Component => {
//   return entryPoints[entryKey]
// }

export const setupInstance = (
  config: FrontendConfig,
  adminPortalEnabled: 0 | 1,
): FrontendInstance => {
  return {
    AUTH0_ID: config.auth0_client_id,
    ROUTER: buildRouter(config.router, adminPortalEnabled),
    SENTRY_ID: config.sentry_dsn,
  }
}

const buildRouter = (routeKey: string, adminPortalEnabled: 0 | 1): Router => {
  const routes = [ROUTES[routeKey]]
  // this override is to temporarily stop the admin portal overriding the advice routes until we conditionally override for admins only
  if (adminPortalEnabled) {
    routes.push(getAdminPortalRoutes(routeKey))
  }
  //TODO: Update this to be fed by whitelabel instead of conditionals
  console.log('Freemium Enabled:', freemiumEnabled.value)
  if (routeKey === 'otivoRouter' && (freemiumEnabled.value || adviserHomepageEnabled.value)) {
    routes.push(publicRoutes)
  }
  return createRouter(routes.flat() as RouteRecordRaw[])
}

const getAdminPortalRoutes = (routeKey: string): RouteRecordRaw[] => {
  switch (routeKey) {
    case 'otivoRouter':
      return adminPortalRoutes(useSessionStore(), useUserStore(), useAccountFlagsStore())
    case 'cfsRouter':
      return cfsAdminPortalRoutes(useSessionStore(), useUserStore())
    default:
      throw new Error('Invalid route key')
  }
}
